import { getApplication } from '@ms/yammer-libs-static-config';

import { useAndReportExperimentTreatment } from '../experiments';

type UseShouldUseTeamsFocusNavigation = () => boolean;
export const useShouldUseTeamsFocusNavigation: UseShouldUseTeamsFocusNavigation = () => {
  const appType = getApplication();
  const isTeamsPersonal = appType === 'YAMMER_TEAMS_PERSONAL_APP';
  const teamsFocusCommandsInEngageApp = useAndReportExperimentTreatment('TeamsFocusCommandsInEngageApp') === true;

  return isTeamsPersonal && teamsFocusCommandsInEngageApp;
};
